export const positionTypes = {
  CUSTOM: 'custom',
  ARTICLE: 'article',
  TIMETRACKING: 'time',
  MITE: 'mite',
}

export default {
  // map positiontypes to enum values
  positionTypes,
}
